// 大智慧分享
export function share(title,url) {
	let origin = location.href.split('#')[0];
	url = origin + '#' +url;

	url = url.replace("DZHSPECIAL","DZH");
	if(typeof DzhAppJs != 'undefined') {
		DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('rtmenu','[{"label":"分享","link":"dzh_browser_url&goto=0&screen=143&title='+title+'&text=献给徘徊在选牛股路上的选手，可以从了解涨停股的气质开始～&url='+url+'&icon=http://static.yundzh.com/logo.png&kind=55"}]', null)
	}
}


// WEBPACK FOOTER //
// ./src/utils/dzh.js